import {Component} from 'react';

import {GTM_EVENT_CHECKOUT} from 'redux/middleware/googleTagManager/eventNames';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false};
  }

  static getDerivedStateFromError(error) {
    if (error) {
      return {hasError: true};
    }
  }

  componentDidCatch(error, errorInfo) {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: GTM_EVENT_CHECKOUT,
        event_action: 'exception',
        error_line: btoa(error.stack),
        non_interaction: true,
      });
    }
  }

  render() {
    return this.props.children;
  }
}
